<template>
  <div class="q-pt-sm">
    <div
      :class="$q.dark.mode ? '' : 'text-primary'"
      class="q-px-sm text-subtitle1 text-bold"
    >
      Price History of {{ symbol }}
    </div>
    <q-table
      :rows="priceHistoryData"
      :columns="columns"
      separator="cell"
      :pagination="pagination"
      binary-state-sort
      sortable
      :class="$q.dark.mode ? 'my-sticky-dynamic-dark' : 'my-sticky-dynamic'"
    ></q-table>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { ref } from "vue";
const $store = useStore();

// Define the props
const props = defineProps({
  symbol: {
    type: String,
    required: true,
  },
});

const priceHistoryData = ref([]);
priceHistoryData.value = $store.state.core.historyDataSearch;

const pagination = ref({
  sortBy: "date",
  descending: true,
  page: 1,
  rowsPerPage: 20,
});

const columns = [
  //   {
  //     name: "symbol",
  //     label: "Symbol",
  //     align: "center",
  //     field: "symbol",
  //     required: true,
  //   },
  {
    name: "date",
    label: "Date",
    field: "date",
    align: "center",
    required: true,
  },
  {
    name: "close",
    label: "LTP",
    field: "close",
    align: "center",
    required: true,
  },
  {
    name: "change",
    label: "% Change",
    field: "change",
    align: "center",
    required: true,
    format: (val, row) => (row.change * 100)?.toFixed(2),
  },
  {
    name: "",
    label: "high",
    field: "high",
    sortable: true,
    align: "center",
    required: true,
  },
  {
    name: "low",
    label: "Low",
    field: "low",
    sortable: true,
    align: "center",
    required: true,
  },
  {
    name: "open",
    label: "Open",
    field: "open",
    sortable: true,
    align: "center",
    required: true,
  },
  {
    name: "volume",
    label: "Quantity",
    field: "volume",
    sortable: true,
    align: "center",
    required: true,
  },
  //   {
  //     name: "trunover",
  //     label: "Trun Over",
  //     field: "trunover",
  //     sortable: true,
  //     align: "center",
  //     required: true,
  //   },
];
</script>
